/* eslint-disable */
/* global window */
const EMULATE_ERROR_CHANCE = 0.2
const DEFAULT_EMULATE_TIMEOUT = 2000
const DEFAULT_EMULATE_DATA = {
  address: 'tbnb12hlquylu78cjylk5zshxpdj6hf3t0tahwjt3ex',
  // public key from: https://testnet-dex.binance.org/api/v1/tx/297DC2BA93AD6E0D813EA7335C88A48CA6FC1544A3B3D8937306999C2539036B?format=json
  // pk = crypto.getPublicKey('03e81c081b2879f63577d4e790838f57c217e7efe2fc14eb32f154eef1bd457224')
  //      .encode('hex')
  publicKey:
    '04e81c081b2879f63577d4e790838f57c217e7efe2fc14eb32f154eef1bd457224d60251d1d28bdbaaf943a478328cb148d49be5f6b87986030a4b52cb98b78109',
  signature:
    'd7367f30b85509eb59161171c9bdefa5fe241c254c3da07b189bbfdfeb204e2e12b72bdb594574202b6457b538c47653677cf61a732d39686bbb0f3d9f5405cb',
}

const WINDOW_INSTANCE_KEY = 'CoinomiDexBridge'

export class CoinomiDexBridge {
  static CALLBACK_ADDRESS = 'address'

  static CALLBACK_PUBLIC_KEY = 'public_key'

  static CALLBACK_SIGN_TRANSACTION = 'sign_transaction'

  static ERRCODE_USER_CANCEL = 'ERR_USER_CANCEL'

  static getInstance(...args) {
    window[WINDOW_INSTANCE_KEY] = window[WINDOW_INSTANCE_KEY] || new CoinomiDexBridge(...args)
    return window[WINDOW_INSTANCE_KEY]
  }

  constructor(
    emulate = false,
    emulateData = DEFAULT_EMULATE_DATA,
    emulateWait = DEFAULT_EMULATE_TIMEOUT
  ) {
    this._apiVersion = '1'
    this._init = false
    this._listener = null
    this._emulate = emulate
    this._emulateData = emulateData
    this._emulateWait = emulateWait
  }

  init = async () => {
    this._init = true
  }

  hasIntegration = () => this.hasCoinomiIntegration()

  hasCoinomiIntegration = () => {
    if (this._emulate === true) {
      return true
    }
    if (this._isDesktop() || this._isAndroid() || this._isIOS()) {
      return true
    }
    return false
  }

  setOnCallbackListener = listener => {
    if (!this.hasCoinomiIntegration()) {
      throw new Error('Unable to set Coinomi callback listener. Coinomi was not found.')
    }
    // delay emulate
    if (this._emulate) {
      this._listener = (...args) => {
        console.info('Coinomi: emulate delay start')
        if (Math.random() <= EMULATE_ERROR_CHANCE) {
          // ~20% chance of getting an error
          // emulate ERR_USER_CANCEL
          args = [{ code: 'ERR_USER_CANCEL', message: 'User cancelled' }]
        }
        setTimeout(() => {
          console.info('Coinomi: emulate delay end, calling listener')
          listener(...args)
        }, this._emulateWait)
      }
      return
    }
    this._listener = listener
  }

  checkApiVersion = () => {
    if (this._emulate === true) {
      return true
    }
    return (
      this.hasCoinomiIntegration() &&
      window.CoinomiBridgeAndroid.getApiVersion() === this._apiVersion
    )
  }

  // async call (use `await`)
  getAddress = () =>
    new Promise((resolve, reject) => {
      this.setOnCallbackListener((err, type, data) => {
        if (err) {
          console.error(`Coinomi error! (${err.code}, ${err.message})`)
          reject(err)
          return null
        }
        const { address, publicKey } = data
        switch (type) {
          case CoinomiDexBridge.CALLBACK_ADDRESS:
            resolve({ address, publicKey })
            return true
          default:
            reject(new Error('Unexpected Coinomi response type'))
            return false
        }
      })
      if (this._emulate === true) {
        this._listener(null, CoinomiDexBridge.CALLBACK_ADDRESS, {
          address: this._emulateData.address,
          publicKey: this._emulateData.publicKey,
        })
      } else if (this.hasCoinomiIntegration()) {
        if (this._isDesktop()) {
          window.CoinomiBridgeDesktop.getAddress()
        }
        if (this._isAndroid()) {
          window.CoinomiBridgeAndroid.getAddress()
        }
        if (this._isIOS()) {
          window.webkit.messageHandlers.CoinomiBridgeIOS.postMessage({ fn: 'getAddress' })
        }
      } else {
        reject(new Error('Coinomi was not found, unable to get address'))
      }
    })

  // async call (use `await`)
  signTransaction = signDocHex =>
    new Promise((resolve, reject) => {
      this.setOnCallbackListener((err, type, data) => {
        if (err) {
          console.error(`Coinomi error! (${err.code}, ${err.message})`)
          reject(err)
          return
        }
        const { signature, publicKey } = data
        switch (type) {
          case CoinomiDexBridge.CALLBACK_SIGN_TRANSACTION:
            resolve({ signature, publicKey })
            break
          default:
            reject(new Error('Unexpected Coinomi response type'))
        }
      })
      if (this._emulate === true) {
        this._listener(null, CoinomiDexBridge.CALLBACK_SIGN_TRANSACTION, {
          signature: this._emulateData.signature,
          publicKey: this._emulateData.publicKey,
        })
      } else if (this.hasCoinomiIntegration()) {
        if (this._isDesktop()) {
          window.CoinomiBridgeDesktop.signTransaction(signDocHex)
        }
        if (this._isAndroid()) {
          window.CoinomiBridgeAndroid.signTransaction(signDocHex)
        }
        if (this._isIOS()) {
          window.webkit.messageHandlers.CoinomiBridgeIOS.postMessage({
            fn: 'signTransaction',
            data: { rawTransaction: signDocHex },
          })
        }
      } else {
        reject(new Error('Coinomi was not found, unable to sign transaction'))
      }
    })

  _parseCallbackFromCoinomi = json => {
    try {
      const data = JSON.parse(json)
      switch (data._type) {
        case CoinomiDexBridge.CALLBACK_ADDRESS:
          this._listener(data._error, data._type, {
            address: data.address,
            publicKey: data.publicKey,
          })
          break
        case CoinomiDexBridge.CALLBACK_PUBLIC_KEY:
          this._listener(data._error, data._type, {
            publicKey: data.publicKey,
          })
          break
        case CoinomiDexBridge.CALLBACK_SIGN_TRANSACTION:
          this._listener(data._error, data._type, {
            signature: data.signature,
            publicKey: data.publicKey,
            rawTransaction: data.rawTransaction,
          })
          break
        default:
          throw new Error(`Coinomi responded with an unknown data type: ${data._type}`)
      }
    } catch (e) {
      console.error('Coinomi parser error', e)
      throw e
    }
  }

  _isAndroid = () => !!window.CoinomiBridgeAndroid

  _isIOS = () =>
    !!(
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.CoinomiBridgeIOS
    )

  _isDesktop = () => !!window.CoinomiBridgeDesktop
}

export default {
  getInstance: (...args) => CoinomiDexBridge.getInstance(...args),
}
